import React from 'react'
import './App.css'
import Navigation from './components/Navigation'
import MainBody from './components/MainBody'
import Analysis from './components/Analysis'
import Help from './components/Help'
import Footer from './components/Footer'
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom'

function App() {
  return (
    <Router>
      <React.Fragment>
        <Navigation />
        <Switch>
          <Route path="/" exact component={MainBody} />
          <Route path="/analysis" exact component={Analysis} />
          <Route path="/help" exact component={Help} />
        </Switch>
        <Footer />
      </React.Fragment>
    </Router>
  )
}

export default App
